import React from 'react'

export default function ArrowRight(props) {
  return (
    <svg
      width={props.width ? props.width : '14'}
      height={props.height ? props.height : '12'}
      viewBox='0 0 14 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.84679 0.290325L7.90503 0.21967C8.15736 -0.0506931 8.55443 -0.0714902 8.82903 0.157278L8.89497 0.21967L13.795 5.46967L13.824 5.50264L13.8626 5.55352L13.9127 5.63695L13.9501 5.7215L13.9749 5.80051L13.9952 5.91143L14 6L13.998 6.05643L13.9858 6.15054L13.9652 6.23411L13.9344 6.31742L13.8978 6.39053L13.8462 6.46909L13.795 6.53033L8.89497 11.7803C8.62161 12.0732 8.17839 12.0732 7.90503 11.7803C7.65269 11.51 7.63328 11.0845 7.84679 10.7903L7.90503 10.7197L11.6088 6.75H0.7C0.313401 6.75 0 6.41421 0 6C0 5.58579 0.313401 5.25 0.7 5.25H11.6102L7.90503 1.28033C7.65269 1.00997 7.63328 0.584544 7.84679 0.290325L7.90503 0.21967L7.84679 0.290325Z'
        fill={props.color ? props.color : 'white'}
      />
    </svg>
  )
}
